define(function ( require ) {
    'use strict';

    var Backbone = require('backbone');
    var AppConfig = require('config/application');

    return Backbone.Model.extend({

        urlRoot: function () {
            return AppConfig.host + '/rest/dialer/auto-recall-config';
        },

        defaults: {
            is_active: false,
            attempts_count: 1,
            interval_min: 5,
            greeting: ''
        },

        validation: {
            attempts_count: function(value) {
                if(value < 1) {
                    return 'Количество попыток дозвона: Минимальное значение 1';
                }
            },
            interval_min: function(value) {
                if(value < 5) {
                    return 'Интервал между звонками: Минимальное значение 5';
                }
            },
        }
    });
});
